<div *ngFor="let action of actions" class="action">
    <div class="icon" *ngLet="(action.tooltip | async) || '' as actionTooltip" [matTooltip]="actionTooltip | translate">
        <ng-container [ngSwitch]="action.type">
            <a
                *ngSwitchCase="'LINK'"
                [routerLink]="action.routePath"
                (click)="routeClicked(action.id)"
                class="action-link"
                [ngClass]="action.icon.iconClass ?? ''"
                [attr.automation-id]="action.automation"
            >
                <p-icon [name]="action.icon.name" [size]="action.icon.size ?? 'md'" [color]="iconColor" hoverColor="logo-light"></p-icon>
            </a>
            <span
                *ngSwitchCase="'MENU'"
                (click)="iconClicked(action.id)"
                [matMenuTriggerFor]="menu"
                (menuOpened)="toggleMenuOpen(action.id)"
                (menuClosed)="toggleMenuOpen(action.id)"
                [attr.automation-id]="action.automation"
            >
                <p-icon
                    [ngClass]="{ highlighted: isMenuOpen && action.id === navAction.Notification }"
                    [name]="action.icon.name"
                    [size]="action.icon.size ?? 'md'"
                    [color]="iconColor"
                    hoverColor="logo-light"
                >
                </p-icon>
                <div *ngIf="action.badge?.show | async" [class]="'psudo'" [style.backgroundColor]="action.badge?.color"></div>
            </span>
            <p-icon
                *ngSwitchCase="'BUTTON'"
                [ngClass]="action.icon.iconClass ?? ''"
                (click)="iconClicked(action.id)"
                [name]="action.icon.name"
                [size]="action.icon.size ?? 'md'"
                [attr.automation-id]="action.automation"
                [color]="iconColor"
                hoverColor="logo-light"
            >
            </p-icon>
        </ng-container>
    </div>
</div>
<mat-menu #menu="matMenu" class="open-menu">
    <ng-template matMenuContent>
        <div (click)="$event.stopPropagation()" [ngSwitch]="mode">
            <p-user-notifications *ngSwitchCase="navAction.Notification"></p-user-notifications>
            <p-search *ngSwitchCase="navAction.Search" (closed)="menu.close.emit()"></p-search>
        </div>
    </ng-template>
</mat-menu>
